export default function(a, b) {
  return (b.created.raw > a.created.raw) ? 1 : (b.created.raw < a.created.raw) ? -1 : 0;
}
